import React from 'react';
export function useFocus(state, props) {
    var setFocus = state.setFocus;
    var selectAllOnFocus = props.selectAllOnFocus;
    var _a = React.useState(false), isFocused = _a[0], setFocused = _a[1];
    function focus() {
        setFocus();
    }
    function onInternalFocus(event) {
        var _a;
        setFocused(true);
        if (selectAllOnFocus) {
            (_a = event.target) === null || _a === void 0 ? void 0 : _a['select']();
        }
    }
    function onInternalBlur(event) {
        setFocused(false);
    }
    return {
        focus: focus,
        onBlur: onInternalBlur,
        onFocus: onInternalFocus,
        isFocused: isFocused,
    };
}
